export enum StatusCode {
  Ok = 200,
  NoContent = 204,
  Exist = 227,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  Conflict = 409,
  InternalServerError = 500,
}
